/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';

const style: ouiStyle.InStyle = {
  position: 'relative',
};

const css = {
  ...ouiStyle.makeCss(style),
  width: '128px',
  '&:after': {
    display: ouiStyle.Constants.DisplayProp.block,
    content: '""',
    paddingBottom: '100%',
  },
};

export const TeamMemberProfilePictureContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  return (
    <div
      css={css}
    >
      {children}
    </div>
  );
};
